import { create } from "zustand"

import type { SchoolContactListItem } from "../types"

interface ContactStore {
  contacts: SchoolContactListItem[]
  set: (contacts: SchoolContactListItem[]) => void
  add: (contact: SchoolContactListItem) => void
  getById: (id: string) => SchoolContactListItem | undefined
}

const useContactStore = create<ContactStore>((set, get) => ({
  contacts: [],

  set: (contacts) =>
    set(() => ({
      contacts,
    })),

  add: (contact) =>
    set((state) => ({
      contacts: [...state.contacts, contact],
    })),
  getById: (id) =>
    get().contacts.find((contact) => String(contact.id) === String(id)),
}))

export default useContactStore
